// ============================================================
// SMART CARD LAYOUT ENGINE — variantes ESTRUCTURALES
// ============================================================
// Pura geometría: qué regiones existen, en qué orden, shell styling,
// alineación del footer, ratio de media por defecto.
// Cero conocimiento de negocio. Añadir una variante = añadir una
// entrada aquí (nunca tocar el motor).
// ============================================================
export interface VariantConfig {
  regions: Array<'media' | 'overlay' | 'header' | 'body' | 'footer'>;
  shell: string;
  footerAlign?: 'bottom' | 'natural';
  mediaRatio?: string; // sugerencia para el consumidor (no impone nada)
}

export const VARIANTS: Record<string, VariantConfig> = {
  default: {
    regions: ['media', 'header', 'body', 'footer'],
    shell: 'bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col',
    footerAlign: 'bottom',
    mediaRatio: '3/4',
  },
  'media-left': {
    regions: ['media', 'header', 'body', 'footer'],
    shell: 'bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-row',
    footerAlign: 'bottom',
    mediaRatio: '1/1',
  },
  compact: {
    regions: ['media', 'body'],
    shell: 'bg-white rounded-lg shadow border border-gray-200 overflow-hidden flex flex-col',
    footerAlign: 'natural',
    mediaRatio: '1/1',
  },
  hero: {
    regions: ['media', 'header', 'body', 'footer'],
    shell: 'bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden flex flex-col',
    footerAlign: 'bottom',
    mediaRatio: '16/9',
  },
};
